/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "build/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 7);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = morningstar;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = _;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = angular;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(1), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar, _, angular) {
    'use strict';

    var _groupElement = null;
    var MAX_COLS = 12;
    var MAX_WIDTH = 1200;

    var calculateSelfWidth = function calculateSelfWidth(cols, parentWidth) {
        return cols / MAX_COLS * parentWidth;
    };

    var callWithActiveBreakpoint = function callWithActiveBreakpoint(breakpointObj, width, cb) {
        //Original call was with a dimensions object instead of width
        //so check if param is object and get width value from it if it is
        if (morningstar.asterix.util.isPlainObject(width)) {
            width = width.width;
        }

        var breakpoints = _.chain(breakpointObj).map(function (breakpoint, key) {
            return {
                name: key,
                width: breakpoint
            };
        }).sortBy(function (breakpoint) {
            return breakpoint.width;
        }).value();

        for (var i = 0; i < breakpoints.length; ++i) {
            var breakpoint = breakpoints[i];
            if (width <= breakpoint.width || i + 1 === breakpoints.length) {
                cb(breakpoint);
                break;
            }
        }
    };

    var evaluateCols = function evaluateCols(configEvaluator, expression, callback, unregisterCallbacks) {
        function extractFirstElementThatMeetsCondition(conditions) {
            var r = _.find(conditions, function (e) {
                return e.condition || morningstar.asterix.util.isNumber(e);
            });
            return morningstar.asterix.util.isNumber(r) ? r : r.value;
        }

        if (morningstar.asterix.util.isNumber(expression)) {
            return expression;
        }

        var evaluation = configEvaluator.evaluate(expression, {
            model: true,
            settings: true
        });

        unregisterCallbacks.push(evaluation.listen(function () {
            var reevaluated = evaluation.reEvaluate();
            callback(extractFirstElementThatMeetsCondition(reevaluated));
        }));

        return extractFirstElementThatMeetsCondition(evaluation.evaluated);
    };

    var evaluateColsExpression = function evaluateColsExpression(configEvaluator, expression, component, callback) {
        if (morningstar.asterix.util.isNumber(expression)) {
            // expression is numeric value
            callback(expression);
        } else if (morningstar.asterix.util.isString(expression) && expression !== '') {
            // evaluate and add listener for binding
            var evaluation = configEvaluator.evaluate(expression, {
                model: true,
                settings: true
            });

            callback(evaluation.evaluated);

            component.addUnregisterCallback(evaluation.listen(function () {
                var value = evaluation.reEvaluate();
                callback(value);
            }));
        }
    };

    var evaluateShowExpression = function evaluateShowExpression(configEvaluator, expression, component, callback) {
        function evaluationValueSetter(value) {
            callback(value && value.toString().toLowerCase() === 'true');
        }

        // evaluate and add listener for binding
        if (morningstar.asterix.util.isString(expression) && expression !== '') {
            var evaluation = configEvaluator.evaluate(expression, {
                model: true,
                settings: true
            });

            evaluationValueSetter(evaluation.evaluated);

            _.each(evaluation.references, function handleSelectorReference(reference) {
                component.addUnregisterCallback(reference.listen(function (value) {
                    evaluationValueSetter(value);
                }));
            });
        } else if (morningstar.asterix.util.isBoolean(expression)) {
            // expression is boolean value i.e true/false
            callback(expression);
        }
    };

    var getGroupElementClone = function getGroupElementClone() {
        var ret;
        if (!_groupElement) {
            _groupElement = angular.element(__webpack_require__(9));
        }

        ret = _groupElement.clone();
        return ret;
    };

    var triggerBreakpointListeners = function triggerBreakpointListeners(scope) {
        morningstar.asterix.util.each(scope.breakpointListeners, function (cb) {
            cb(scope.breakpoint);
        });
    };

    var triggerWidthListeners = function triggerWidthListeners(scope, dimensions) {
        morningstar.asterix.util.each(scope.widthListeners, function (cb) {
            cb(dimensions);
        });
    };

    module.exports = {
        calculateSelfWidth: calculateSelfWidth,
        callWithActiveBreakpoint: callWithActiveBreakpoint,
        evaluateCols: evaluateCols,
        evaluateColsExpression: evaluateColsExpression,
        evaluateShowExpression: evaluateShowExpression,
        getGroupElementClone: getGroupElementClone,
        triggerBreakpointListeners: triggerBreakpointListeners,
        triggerWidthListeners: triggerWidthListeners,
        MAX_COLS: MAX_COLS,
        MAX_WIDTH: MAX_WIDTH
    };
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2), __webpack_require__(0), __webpack_require__(1), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, morningstar, _, helper) {
    'use strict';

    container.$inject = ["mstarDimensions", "mstarDebounce", "$interpolate", "$log", "$compile"];
    var _eventTopicExpanded = 'ecContainerExpanded',
        _eventTopicCollapsed = 'ecContainerCollapsed';

    angular.module('ecContainer', ['mstarCore', 'ngSanitize']).directive('ecContainer', container);

    function container(mstarDimensions, mstarDebounce, $interpolate, $log, $compile) {
        controllerFn.$inject = ["$scope", "$element"];
        return {
            restrict: 'E',
            require: ['mstarComponentId', '^?ecSection', 'ecContainer'],
            scope: {},
            transclude: true,
            template: __webpack_require__(8),
            controller: controllerFn,
            link: linkFn
        };

        function controllerFn($scope, $element) {
            $scope.groups = [];
            $scope.sections = [];
            $scope.widthListeners = [];
            $scope.breakpointListeners = [];

            var parentSection = $element.parent().controller('ecSection');
            $scope.parent = parentSection;

            var configEvaluator = null;
            var mstarComponent = $element.controller('mstarComponentId');

            /* jshint validthis: true */
            this.trigger = function trigger() {
                return mstarComponent.getComponentInstance().trigger.apply(mstarComponent.getComponentInstance(), arguments);
            };

            this.registerSection = function registerSection(section, showFlagSetter) {
                configEvaluator = configEvaluator || new morningstar.asterix.ConfigEvaluator(mstarComponent.getComponentId(), morningstar.asterix.instanceRegistry);

                this.preProcessSettings();

                var i = 0;
                while (section.element.parent('div[data-ng-transclude]').length === 0) {
                    section.element = section.element.parent();
                    if (i++ > 20) {
                        break;
                    }
                }

                $scope.sections.push(section);
                section.config = section.sectionId && $scope.sectionSettings[section.sectionId] ? $scope.sectionSettings[section.sectionId] : {};

                helper.evaluateShowExpression(configEvaluator, section.config.show, mstarComponent, showFlagSetter);

                var defaultSectionCopy = getSettingCopyOrDefault($scope.settings.get('defaultSection'));
                section.config = morningstar.asterix.util.merge({}, defaultSectionCopy, section.config);
                section.originalConfig = morningstar.asterix.util.merge({}, section.config);

                if (section.title) {
                    section.headerId = $scope.namespaceId('sectionHeader-' + (section.sectionId || section.$id));
                }
                section.panelId = $scope.namespaceId('sectionPanel-' + (section.sectionId || section.$id));

                if (section.config.hasOwnProperty('titleTemplate')) {
                    if (!section.config.titleTemplate) {
                        section.title = null;
                    } else {
                        // hack: see if $parent has "instance", otherwise use own scope
                        $scope.$watch(function () {
                            return $interpolate(section.config.titleTemplate)($scope.$parent.instance ? $scope.$parent : $scope);
                        }, function (value) {
                            section.title = value;
                            section.element.removeClass('ec-section--no-title');
                            if (!section.headerId) {
                                section.headerId = $scope.namespaceId('sectionHeader-' + (section.sectionId || section.$id));
                            }
                        });
                    }
                }

                if (section.config.hasOwnProperty('titleTooltipLabelId')) {
                    section.titleTooltipLabelId = section.config.titleTooltipLabelId;
                }

                $scope.hasUnprocessedSections = true;
                $scope.scheduleSetup();
            };

            this.unregisterSection = function unregisterSection(section) {
                $scope.sections.splice($scope.sections.indexOf(section), 1);
                $scope.hasUnprocessedSections = true;
                $scope.scheduleSetup();
            };

            var hasPreProcessedSettings = false;

            this.preProcessSettings = function preProcessSettings() {
                if (hasPreProcessedSettings) {
                    return;
                }

                hasPreProcessedSettings = true;

                $scope.sectionSettings = getSettingCopyOrDefault($scope.settings.get('sections'));

                for (var sectionKey in $scope.sectionSettings) {
                    var section = $scope.sectionSettings[sectionKey];
                    section.breakpoints = section.breakpoints || {};

                    for (var breakpointKey in $scope.viewBreakpoints) {
                        section.breakpoints[breakpointKey] = getBreakpointDefinition(breakpointKey, section.breakpoints);

                        if (section.breakpoints.defaults) {
                            section.breakpoints[breakpointKey] = morningstar.asterix.util.merge({}, section.breakpoints.defaults, section.breakpoints[breakpointKey]);
                        }
                    }
                }

                $scope.breakpointSettings = getSettingCopyOrDefault($scope.settings.get('breakpoints'));

                for (var _breakpointKey in $scope.viewBreakpoints) {
                    var breakpointSetting = getBreakpointDefinition(_breakpointKey, $scope.breakpointSettings);

                    if ($scope.breakpointSettings.defaults) {
                        if (!breakpointSetting.groups && $scope.breakpointSettings.defaults.groups) {
                            // no groups specified - inherit from defaults
                            breakpointSetting.groups = morningstar.asterix.util.merge({}, $scope.breakpointSettings.defaults.groups);
                        }

                        breakpointSetting.collapserPosition = breakpointSetting.collapserPosition || $scope.breakpointSettings.defaults.collapserPosition;
                        breakpointSetting.autoCollapseMode = breakpointSetting.autoCollapseMode || $scope.breakpointSettings.defaults.autoCollapseMode;
                    }

                    $scope.breakpointSettings[_breakpointKey] = breakpointSetting;
                }

                function getBreakpointDefinition(key, breakpoints, attempt) {
                    //find the breakpoint definition
                    //breakpoint reference by string - inherit some other breakpoint setting
                    var definition;
                    attempt = attempt || 1;

                    //this prevents an infinite loop of lookups
                    if (attempt > Object.keys(breakpoints).length) {
                        definition = {};
                    } else if (morningstar.asterix.util.isString(breakpoints[key])) {
                        attempt++;
                        definition = getBreakpointDefinition(breakpoints[key], breakpoints, attempt);
                    } else {
                        definition = morningstar.asterix.util.merge({}, breakpoints[key] || {});
                    }

                    return definition;
                }
            };

            this.collapseAllSectionsAndGroups = function collapseAllSectionsAndGroups(currentSectionOrGroup) {
                morningstar.asterix.util.each($scope.groups, function (group) {
                    var groupScope = $scope.useCalculatedWidth ? group.scope : group.groupElement.scope();
                    if (!groupScope.isExpanded) {
                        return;
                    }
                    if (currentSectionOrGroup !== groupScope && groupScope.collapsible) {
                        groupScope.close();
                        morningstar.asterix.instanceRegistry.get($scope.instance.modulePath).trigger(_eventTopicCollapsed, ['group', groupScope.groupId]);
                    }
                    _.each(group.sections, function (section) {
                        if (section.isExpanded && section !== currentSectionOrGroup && section.col !== 0 && section.title) {
                            section.close();
                            morningstar.asterix.instanceRegistry.get($scope.instance.modulePath).trigger(_eventTopicCollapsed, ['section', section.sectionId]);
                        }
                    });
                });
            };

            this.toggle = function toggle(section) {
                var isExpanded = section.isExpanded;
                if ($scope.settings.get('enableToggleForExpand')) {
                    this.collapseAllSectionsAndGroups(section);
                }

                morningstar.asterix.util.each(section.config.triggerSections, function (innerSection) {
                    if (!isExpanded) {
                        innerSection.open();
                    } else {
                        innerSection.close();
                    }
                });
            };

            this.getLevel = function getLevel() {
                return parentSection ? parentSection.getLevel() + 1 : 0;
            };

            this.addWidthListener = function addWidthListener(callback) {
                $scope.widthListeners.push(callback);

                return function unregister() {
                    $scope.widthListeners.splice($scope.widthListeners.indexOf(callback), 1);
                };
            };

            this.addBreakpointListener = function addBreakpointListener(callback) {
                $scope.breakpointListeners.push(callback);

                return function unregister() {
                    $scope.breakpointListeners.splice($scope.breakpointListeners.indexOf(callback), 1);
                };
            };

            this.scheduleSetup = function scheduleSetup() {
                $scope.scheduleSetup();
            };

            $scope.level = this.getLevel();
        }

        function linkFn(scope, elem, attr, controllers) {
            var mstarComponent = controllers[0],
                container = controllers[2];
            var attachTo = elem.children('[data-ng-transclude]').eq(0);

            scope.show = true;

            // binds settings, labels, formatter and templates to scope properties
            mstarComponent.bindConfig(scope);

            scope.viewBreakpoints = scope.settings.get('viewBreakpoints');
            scope.useCalculatedWidth = scope.settings.get('useCalculatedWidth') || false;

            var configEvaluator = new morningstar.asterix.ConfigEvaluator(scope.instance.modulePath, morningstar.asterix.instanceRegistry);
            var prevWidth = null;
            var prevBreakpoint = null;
            var dimensionsInstance = mstarDimensions(scope, elem);

            if (scope.useCalculatedWidth) {
                scope.scheduleSetup = mstarDebounce(function scheduleSetup() {
                    if (!scope.parentWidth) {
                        scope.parentWidth = elem.width();
                    }

                    scope.$applyAsync(function () {
                        handleWidthChange(helper.MAX_COLS, scope.parentWidth);
                    });
                });

                if (scope.parent == null) {
                    dimensionsInstance.addListener(function (dimensions) {
                        var width = Math.min(dimensions.width, helper.MAX_WIDTH);
                        if (prevWidth === width) {
                            return;
                        }

                        prevWidth = width;

                        scope.parentWidth = width;
                        scope.scheduleSetup();
                    });
                } else {
                    mstarComponent.addUnregisterCallback(scope.parent.addWidthListener(function (parentWidth) {
                        scope.parentWidth = parentWidth;
                        scope.scheduleSetup();
                    }));

                    scope.parentWidth = scope.parent.getWidth();
                    scope.scheduleSetup();
                }
            } else {
                if (scope.parent == null) {
                    dimensionsInstance.addListener(function (dimensions) {
                        scope.$apply(function () {
                            handleDimensions(dimensions);
                        });
                    });
                } else {
                    mstarComponent.addUnregisterCallback(scope.parent.addWidthListener(function () {
                        handleDimensions({
                            width: elem.width()
                        });
                    }));
                }

                scope.scheduleSetup = mstarDebounce(function scheduleSetup() {
                    if (scope.level < 2) {
                        scope.$evalAsync(function () {
                            handleDimensions({
                                width: elem.width()
                            }, true);
                        });
                        return;
                    }

                    if (scope.hasScheduledSetup === true) {
                        return;
                    }

                    scope.hasScheduledSetup = true;
                    dimensionsInstance.requestDimensions(function (dimensions) {
                        scope.$evalAsync(function () {
                            handleDimensions(dimensions, true);
                            scope.hasScheduledSetup = false;
                        });
                    });
                }, 1);
            }

            var containerShowExpression = scope.settings.contains('show') ? scope.settings.get('show') : null;
            helper.evaluateShowExpression(configEvaluator, containerShowExpression, mstarComponent, function (showFlag) {
                scope.show = showFlag;
            });

            setupNgRepeatWatch();

            function findSection(sectionId) {
                return _.find(scope.sections, function (section) {
                    return section.sectionId === sectionId;
                });
            }

            function getGroupDefinitionSections(groupDefinition) {
                return groupDefinition.sections === 'all' ? _.map(scope.sections, function (section, key) {
                    return section.sectionId;
                }) : groupDefinition.sections;
            }

            function createGroup(groupDefinition, parentWidth) {
                if (groupDefinition.cols == null) {
                    throw new Error('Missing cols for group definition: ' + groupDefinition.id);
                }

                if (groupDefinition.cols > 0 || morningstar.asterix.util.isString(groupDefinition.cols) && groupDefinition.cols.indexOf('{{') !== -1) {
                    var groupScope = scope.$new();

                    groupScope.show = true;

                    groupScope.collapsible = groupDefinition.collapsible;
                    groupScope.groupId = groupDefinition.id;
                    if (groupScope.collapsible) {
                        // this is an ugly hack to force child sections not to be collapsible
                        scope.$applyAsync(function () {
                            _.each(group.sections, function (section) {
                                section.isExpanded = groupScope.isExpanded;
                                section.collapsible = false;
                            });
                        });
                    }

                    if (groupDefinition.titleLabelId) {
                        scope.$watch(function () {
                            return $interpolate(scope.labels.get(groupDefinition.titleLabelId))(scope);
                        }, function (value) {
                            groupScope.title = value;
                        }, true);
                    }

                    groupScope.titleTooltipLabelId = groupDefinition.titleTooltipLabelId;

                    if (groupDefinition.autoCollapseMode === 'collapse') {
                        groupScope.isExpanded = false;
                    } else if (groupDefinition.autoCollapseMode === 'expand') {
                        groupScope.isExpanded = true;
                    } else {
                        groupScope.isExpanded = true; // not sure about this default behavior, should probably check breakpoint's setting instead
                    }

                    groupScope.classSuffix = morningstar.asterix.util.string.dashCase(groupDefinition.id);
                    groupScope.groupSectionPanelId = scope.namespaceId('groupSectionPanel-' + (groupScope.groupId || groupScope.$id));

                    groupScope.open = function openGroup() {
                        groupScope.isExpanded = true;
                    };

                    groupScope.close = function closeGroup() {
                        groupScope.isExpanded = false;
                    };

                    groupScope.classWithModifier = function classWithModifier(baseClass) {
                        return !groupScope.classSuffix ? baseClass : baseClass + ' ' + baseClass + '--' + groupScope.classSuffix;
                    };

                    groupScope.toggle = function toggleGroup() {
                        if (scope.settings.get('enableToggleForExpand')) {
                            container.collapseAllSectionsAndGroups(groupScope);
                        }
                        groupScope.isExpanded = !groupScope.isExpanded;
                        _.each(group.sections, function (section) {
                            section.isExpanded = groupScope.isExpanded;
                        });
                        mstarComponent.getComponentInstance().trigger(groupScope.isExpanded ? _eventTopicExpanded : _eventTopicCollapsed, ['group', groupDefinition.id]);
                    };

                    groupScope.breakpoint = scope.breakpoint;
                    var unregisterCallbacks = [];
                    if (scope.useCalculatedWidth) {
                        groupScope.$on('$destroy', function () {
                            _.each(unregisterCallbacks, function (cb) {
                                cb();
                            });
                        });
                    }
                    groupScope.cols = groupDefinition.cols;

                    helper.evaluateShowExpression(configEvaluator, groupDefinition.show, mstarComponent, function (showFlag) {
                        if (!showFlag) {
                            groupScope.cols = 0;
                        } else {
                            groupScope.cols = groupDefinition.cols;
                        }
                        groupScope.show = showFlag;
                    });

                    var groupElement = $compile(helper.getGroupElementClone())(groupScope);

                    var group;

                    if (scope.useCalculatedWidth) {
                        group = {
                            cols: groupDefinition.cols,
                            groupElement: groupElement,
                            scope: groupScope,
                            sections: [],
                            sectionDefinitions: [],
                            order: groupDefinition.order,
                            defaultSection: groupDefinition.defaultSection || {},
                            unregisterCallbacks: unregisterCallbacks,
                            destroy: function destroy() {
                                groupScope.$destroy();
                            }
                        };
                    } else {
                        group = {
                            groupElement: groupElement,
                            sections: [],
                            sectionDefinitions: [],
                            order: groupDefinition.order,
                            defaultSection: morningstar.asterix.extend(true, {}, groupDefinition.defaultSection),
                            destroy: function destroy() {
                                groupScope.$destroy();
                            }
                        };
                    }

                    helper.evaluateColsExpression(configEvaluator, groupDefinition.cols, mstarComponent, function (cols) {
                        groupScope.cols = cols;
                        if (scope.useCalculatedWidth) {
                            processGroup(group, parentWidth);
                        }
                    });

                    morningstar.asterix.util.each(getGroupDefinitionSections(groupDefinition), function (s) {
                        var sectionId = null;
                        if (morningstar.asterix.util.isPlainObject(s)) {
                            sectionId = s.sectionId;
                            if (scope.useCalculatedWidth) {
                                s = morningstar.asterix.util.merge({}, s);
                                if (s.cols) {
                                    s.cols = helper.evaluateCols(configEvaluator, s.cols, function colsChanged(cols) {
                                        s.cols = cols;
                                        processGroup(group, parentWidth);
                                    }, unregisterCallbacks);
                                }
                            }
                        } else if (morningstar.asterix.util.isString(s)) {
                            sectionId = s;
                            s = {
                                sectionId: s
                            };
                        }

                        var section = findSection(sectionId);
                        if (section) {
                            if (groupScope.collapsible) {
                                section.isInCollapsibleGroup = true;
                            } else {
                                section.isInCollapsibleGroup = false;
                            }

                            var appendTo = group.groupElement.find('> section > .ec-section__content');
                            section.element.appendTo(appendTo);
                            group.sections.push(section);
                            group.sectionDefinitions.push(s);
                        }
                    });

                    if (scope.useCalculatedWidth) {
                        processGroup(group, parentWidth);
                    }

                    return group;
                } else {
                    morningstar.asterix.util.each(getGroupDefinitionSections(groupDefinition), function (s) {
                        var sectionId = null;
                        if (morningstar.asterix.util.isPlainObject(s)) {
                            sectionId = s.sectionId;
                        } else if (morningstar.asterix.util.isString(s)) {
                            sectionId = s;
                            if (!scope.useCalculatedWidth) {
                                s = {
                                    sectionId: s
                                };
                            }
                        }

                        var section = findSection(sectionId);
                        if (section) {
                            section.element.detach();
                        }
                    });

                    return null;
                }
            }

            function processGroup(group, parentWidth) {
                helper.callWithActiveBreakpoint(scope.viewBreakpoints, parentWidth, function (breakpoint) {
                    group.breakpoint = breakpoint.name;
                    group.width = helper.calculateSelfWidth(group.cols, parentWidth);
                    _.each(group.sections, function (section, i) {
                        morningstar.asterix.util.merge(section.config.breakpoints[breakpoint.name], group.defaultSection, group.sectionDefinitions[i]);
                    });
                });

                processSections(group.sections, group.breakpoint, scope.breakpointSettings[group.breakpoint], group.width);
            }

            function setScopeBreakpoint(width) {
                elem.removeClass(_.map(scope.viewBreakpoints, function (bp, key) {
                    return 'ec-container--' + key;
                }).join(' '));

                //Original call was with a dimensions object instead of width
                //so check if param is object and get width value from it if it is
                if (morningstar.asterix.util.isPlainObject(width)) {
                    width = width.width;
                }

                helper.callWithActiveBreakpoint(scope.viewBreakpoints, width, function (breakpoint) {
                    scope.breakpoint = breakpoint.name;
                });

                elem.addClass('ec-container--' + scope.breakpoint);
            }

            function createGroups(groupDefinitions, parentWidth) {
                var newGroups = [];
                var groupsRow = angular.element('<div class="ms-neat-row"></div>');
                var orphanSections = _.filter(_.pluck(scope.sections, 'sectionId'), function (id) {
                    return id;
                });
                _.chain(groupDefinitions).each(function (groupDefinition, key) {
                    _.each(getGroupDefinitionSections(groupDefinition), function (section) {
                        var sectionId = section.sectionId ? section.sectionId : section;
                        orphanSections.splice(orphanSections.indexOf(sectionId), 1);
                    });

                    groupDefinition.id = key;
                }).sortBy(function (group) {
                    return group.order;
                }).each(function (groupDefinition) {
                    var group = createGroup(groupDefinition, parentWidth);
                    if (group) {
                        newGroups.push(group);
                        groupsRow.append(group.groupElement);
                    }
                });

                _.each(orphanSections, function (sectionId) {
                    var section = findSection(sectionId);
                    section.show = false;
                    section.element.detach();
                });

                if (orphanSections.length > 0) {
                    morningstar.asterix.instrumentation.logger.debug('Orphan sections: ' + orphanSections.join(', '));
                }

                attachTo.find('.ms-neat-row').remove();
                attachTo.append(groupsRow);
                if (scope.groupsRow) {
                    scope.groupsRow.remove();
                }

                scope.groupsRow = groupsRow;

                if (!scope.useCalculatedWidth) {
                    helper.callWithActiveBreakpoint(scope.viewBreakpoints, {
                        width: attachTo.width()
                    }, function (breakpoint) {
                        _.each(newGroups, function (group) {
                            group.breakpoint = breakpoint.name;
                            _.each(group.sections, function (section, i) {
                                section.config.breakpoints[breakpoint.name] = morningstar.asterix.extend(true, {}, section.config.breakpoints[breakpoint.name], group.defaultSection, group.sectionDefinitions[i]);

                                var expression = group.sectionDefinitions[i].show;

                                if (group.defaultSection.show || morningstar.asterix.util.isBoolean(group.defaultSection.show)) {
                                    expression = group.defaultSection.show;
                                }
                                if (section.config.show || morningstar.asterix.util.isBoolean(section.config.show)) {
                                    expression = section.config.show;
                                }
                                helper.evaluateShowExpression(configEvaluator, expression, mstarComponent, function (flag) {
                                    section.updateShow(flag);
                                });
                            });
                        });
                    });
                }

                return newGroups;
            }

            function handleDimensions(dimensions, force) {
                if (dimensions.width <= 0) {
                    return;
                }
                prevWidth = dimensions.width;

                setScopeBreakpoint(dimensions);
                if (prevBreakpoint === scope.breakpoint && !force) {
                    helper.triggerWidthListeners(scope, dimensions);
                    return;
                }

                prevBreakpoint = scope.breakpoint;

                if (!scope.breakpointSettings) {
                    scope.breakpointSettings = getSettingCopyOrDefault(scope.settings.get('breakpoints'));
                }

                var breakpointConfig = scope.breakpointSettings[scope.breakpoint];
                if (breakpointConfig.collapserPosition === 'none') {
                    morningstar.asterix.util.each(scope.sections, function (section) {
                        section.collapsible = false;
                        section.isExpanded = true;
                    });
                }

                var groupDefinitions = breakpointConfig.groups;

                morningstar.asterix.util.each(scope.groups, function (group) {
                    group.destroy();
                });

                var newGroups = [];
                if (groupDefinitions && Object.keys(groupDefinitions).length > 0) {
                    newGroups = createGroups(groupDefinitions);
                } else if (scope.groups && scope.groups.length) {
                    morningstar.asterix.util.each(scope.sections, function (section) {
                        // reset section settings to non-group values
                        section.config.breakpoints[scope.breakpoint] = morningstar.asterix.extend(true, {}, section.originalConfig.breakpoints[scope.breakpoint]);
                        attachTo.append(section.element);
                    });

                    scope.groupsRow.remove();
                    scope.groupsRow = null;
                } else {
                    // reset section settings to non-group values
                    morningstar.asterix.util.each(scope.sections, function (section) {
                        section.isInCollapsibleGroup = false;
                        section.config.breakpoints[scope.breakpoint] = morningstar.asterix.extend(true, {}, section.originalConfig.breakpoints[scope.breakpoint]);
                    });
                }

                scope.groups = newGroups;

                if (scope.groups.length) {
                    _.each(scope.groups, function (group) {
                        processSections(group.sections, group.breakpoint, breakpointConfig);
                    });
                } else {
                    processSections(scope.sections, scope.breakpoint, breakpointConfig);
                }

                helper.triggerWidthListeners(scope, dimensions);
                helper.triggerBreakpointListeners(scope);
            }

            function handleWidthChange(cols, parentWidth) {
                if (parentWidth <= 0) {
                    return;
                }

                container.preProcessSettings();
                var selfWidth = helper.calculateSelfWidth(cols, parentWidth);

                setScopeBreakpoint(selfWidth);
                if (prevBreakpoint === scope.breakpoint && !scope.hasUnprocessedSections) {
                    return;
                }

                prevBreakpoint = scope.breakpoint;

                if (!scope.breakpointSettings) {
                    scope.breakpointSettings = getSettingCopyOrDefault(scope.settings.get('breakpoints'));
                }

                var breakpointConfig = scope.breakpointSettings[scope.breakpoint];
                if (breakpointConfig.collapserPosition === 'none') {
                    morningstar.asterix.util.each(scope.sections, function (section) {
                        section.collapsible = false;
                        section.isExpanded = true;
                    });
                }

                var groupDefinitions = breakpointConfig.groups;

                if (scope.groups) {
                    _.each(scope.groups, function (group) {
                        _.each(group.sections, function (section) {
                            section.element.detach();
                        });
                        group.scope.$destroy();
                    });
                }

                var newGroups = [];
                if (groupDefinitions && Object.keys(groupDefinitions).length > 0) {
                    newGroups = createGroups(groupDefinitions, selfWidth);
                } else if (scope.groups && scope.groups.length) {
                    morningstar.asterix.util.each(scope.sections, function (section) {
                        // reset section settings to non-group values
                        section.config.breakpoints[scope.breakpoint] = getSettingCopyOrDefault(section.originalConfig.breakpoints[scope.breakpoint]);
                        attachTo.append(section.element);
                    });

                    scope.groupsRow.remove();
                    scope.groupsRow = null;
                } else {
                    // reset section settings to non-group values
                    morningstar.asterix.util.each(scope.sections, function (section) {
                        section.isInCollapsibleGroup = false;
                        section.config.breakpoints[scope.breakpoint] = getSettingCopyOrDefault(section.originalConfig.breakpoints[scope.breakpoint]);
                    });
                }

                scope.groups = newGroups;

                if (!scope.groups.length) {
                    processSections(scope.sections, scope.breakpoint, breakpointConfig, selfWidth);
                }

                scope.hasUnprocessedSections = false;
            }

            function processSections(sections, breakpoint, breakpointConfig, parentWidth) {
                var triggerSection = null,
                    prevTriggerSection = null,
                    colSum = 0,
                    triggerSections = [],
                    rowSections = [];

                for (var index = 0; index < sections.length; index++) {
                    var section = sections[index],
                        isLast = index + 1 === sections.length,
                        sectionCols = section.config.breakpoints[breakpoint].cols;

                    triggerSections.push(section);
                    rowSections.push(section);
                    colSum += sectionCols;

                    if (!isLast) {
                        if (colSum + sections[index + 1].config.breakpoints[breakpoint].cols > helper.MAX_COLS) {
                            isLast = true;
                        }
                    }

                    section.setBreakpointClass(breakpoint, sectionCols);

                    if (isTriggerSection(breakpointConfig.collapserPosition, colSum, sectionCols, isLast)) {
                        triggerSection = section;

                        if (!prevTriggerSection) {
                            prevTriggerSection = triggerSection;
                        }

                        if (triggerSection !== prevTriggerSection) {
                            prevTriggerSection = triggerSection;
                            triggerSections.splice(triggerSections.indexOf(section), 1); //todo: check if this can be deleted
                            triggerSections = [section];
                        }

                        triggerSection.config.triggerSections = triggerSections;
                        var collapsible = triggerSection.config.breakpoints[breakpoint].collapsible;
                        triggerSection.collapsible = _.isUndefined(collapsible) ? true : collapsible;
                    } else if (colSum > helper.MAX_COLS) {
                        throw new Error('Invalid column sum');
                    } else {
                        section.collapsible = false;
                    }

                    if (!section.title && !section.isInCollapsibleGroup) {
                        section.isExpanded = true;
                    }

                    //todo: check if this is needed as it's done on line 765 too
                    if (triggerSection) {
                        triggerSection.config.triggerSections = triggerSections;
                    }

                    if (colSum === helper.MAX_COLS || isLast) {
                        if (!section.isInCollapsibleGroup) {
                            if (breakpointConfig.autoCollapseMode === 'collapse') {
                                if (morningstar.asterix.util.any(triggerSections, function (c) {
                                    return c.config.breakpoints[breakpoint].autoCollapseMode === 'expand' || !c.title;
                                })) {
                                    morningstar.asterix.util.each(triggerSections, function (c) {
                                        c.isExpanded = true;
                                    });
                                } else {
                                    morningstar.asterix.util.each(triggerSections, function (c) {
                                        c.isExpanded = false;
                                    });
                                }
                            } else if (morningstar.asterix.util.any(triggerSections, function (c) {
                                return c.isExpanded === true;
                            }) || breakpointConfig.autoCollapseMode === 'expand') {
                                if (morningstar.asterix.util.any(triggerSections, function (c) {
                                    return c.config.breakpoints[breakpoint].autoCollapseMode === 'collapse';
                                })) {
                                    morningstar.asterix.util.each(triggerSections, function (c) {
                                        c.isExpanded = false;
                                    });
                                } else {
                                    morningstar.asterix.util.each(triggerSections, function (c) {
                                        c.isExpanded = true;
                                    });
                                }
                            }
                        }

                        morningstar.asterix.util.each(triggerSections, function (c) {
                            c.canBeCollapsed = breakpointConfig.collapserPosition != null && breakpointConfig.collapserPosition !== 'none' && !c.isInCollapsibleGroup;
                            c.config.triggerSections = triggerSections;
                        });

                        colSum = 0;
                        triggerSection = null;
                        prevTriggerSection = null;
                        var elems = angular.element(_.map(rowSections, function (c) {
                            return c.element[0];
                        }));
                        elems.filter('.ms-neat-row > *').unwrap();
                        elems.wrapAll('<div class=\'ms-neat-row\'/>');
                        triggerSections = [];
                        rowSections = [];
                    }

                    if (scope.useCalculatedWidth) {
                        section.handleWidthChange(section.config.breakpoints[breakpoint].cols, parentWidth);
                    }
                }

                attachTo.find('.ms-neat-row').filter(function () {
                    return !this.childNodes.length;
                }).remove();

                function isTriggerSection(collapserPosition, colSum, cols, isLast) {
                    return collapserPosition === 'individual' || collapserPosition === 'firstPerRow' && colSum - cols === 0 || collapserPosition === 'lastPerRow' && (colSum === helper.MAX_COLS || isLast);
                }
            }

            /**
             * This checks for sections created using ngRepeat and watches for changes in the data
             * so that if there is a change the sections can be processed and set up again
             */
            function setupNgRepeatWatch() {
                var ngRepeatMatch = attachTo.html().match(/<!-- ngRepeat: (.*?) -->/);
                if (ngRepeatMatch && ngRepeatMatch.length === 2) {
                    var match = ngRepeatMatch[1].match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
                    if (match.length >= 3) {
                        scope.$parent.$watchCollection(match[2], function () {
                            scope.hasUnprocessedSections = true;
                            scope.scheduleSetup();
                        });
                    }
                }
            }
        }

        function getSettingCopyOrDefault(obj) {
            if (obj) {
                return morningstar.asterix.util.cloneObject(obj);
            }
            return {};
        }
    }
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2), __webpack_require__(0), __webpack_require__(1), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, morningstar, _, helper) {
    'use strict';

    section.$inject = ["$compile", "mstarDimensions", "$timeout"];
    var _eventTopicExpanded = 'ecContainerExpanded',
        _eventTopicCollapsed = 'ecContainerCollapsed';

    angular.module('ecContainer').directive('ecSection', section);

    function section($compile, mstarDimensions, $timeout) {
        // standalone sections claim their full available width
        controllerFn.$inject = ["$scope", "$element"];
        var sectionDefaults = {
            breakpoints: {
                small: {
                    cols: helper.MAX_COLS
                },
                medium: {
                    cols: helper.MAX_COLS
                },
                large: {
                    cols: helper.MAX_COLS
                },
                xlarge: {
                    cols: helper.MAX_COLS
                }
            }
        };

        return {
            restrict: 'E',
            require: ['^?ecContainer', '^?mstarComponentId'],
            scope: {
                title: '@',
                subTitle: '@',
                sectionId: '@',
                titleTooltipLabelId: '@'
            },
            transclude: true,
            template: function template(elem, attrs) {
                if (!attrs.templateType || attrs.templateType === 'default') {
                    return __webpack_require__(13);
                }

                switch (attrs.templateType) {
                    case 'light':
                        return __webpack_require__(10);
                    default:
                        morningstar.asterix.instrumentation.logger.fatal(new Error('(ec-section) could not find template type: ' + attrs.templateType));
                }
            },
            controller: controllerFn,
            link: linkFn
        };

        function controllerFn($scope, $element) {
            var parentContainer = $element.parent().controller('ecContainer'),
                parentSection = $element.parent().controller('ecSection'),
                parent = getParent();

            $scope.widthListeners = [];
            $scope.breakpointListeners = [];
            $scope.parent = parent;
            $scope.parentType = !parent ? null : parent === parentSection ? 'section' : 'container';

            /* jshint validthis: true */
            this.getLevel = function getLevel() {
                return parent && parent.getLevel ? parent.getLevel() + 1 : 0;
            };

            $scope.level = this.getLevel();

            this.getWidth = function getWidth() {
                return $scope.width;
            };

            this.addWidthListener = function addWidthListener(callback) {
                $scope.widthListeners.push(callback);

                return function unregister() {
                    $scope.widthListeners.splice($scope.widthListeners.indexOf(callback), 1);
                };
            };

            this.addBreakpointListener = function addBreakpointListener(callback) {
                $scope.breakpointListeners.push(callback);

                return function unregister() {
                    $scope.breakpointListeners.splice($scope.breakpointListeners.indexOf(callback), 1);
                };
            };

            function getParent() {
                var parentObj;

                if (parentContainer && parentSection) {
                    if (parentContainer.getLevel() > parentSection.getLevel()) {
                        parentObj = parentContainer;
                    } else {
                        parentObj = parentSection;
                    }
                } else if (parentContainer) {
                    parentObj = parentContainer;
                } else {
                    parentObj = parentSection;
                }

                return parentObj;
            }
        }

        function linkFn(scope, elem, attr, controllers) {
            var container = controllers[0],
                mstarComponent = controllers[1],
                breakpointClasses = {};

            elem.addClass('ec-section');
            scope.element = elem;

            if (mstarComponent) {
                mstarComponent.bindConfig(scope);
                scope.viewBreakpoints = scope.settings.get('viewBreakpoints');
                scope.useCalculatedWidth = scope.settings.get('useCalculatedWidth') || false;
            } else {
                scope.viewBreakpoints = morningstar.asterix.config.getBaseSettings().viewBreakpoints;
                scope.useCalculatedWidth = morningstar.asterix.config.getBaseSettings().useCalculatedWidth || false;
            }

            scope.templates = _.assign({
                containerSectionTitle: __webpack_require__(12),
                containerSectionSubtitle: __webpack_require__(11)
            }, scope.templates);

            // by default section should be visible
            scope.show = true;
            //because cols is used in section.html it must be initialized,
            scope.cols = helper.MAX_COLS;

            if (!attr.sectionId) {
                if (mstarComponent && mstarComponent.getComponentType() !== 'ecContainer') {
                    scope.sectionId = mstarComponent.getOwnComponentId();
                }
            }

            if (scope.sectionId) {
                scope.classSuffix = morningstar.asterix.util.string.dashCase(scope.sectionId);
                elem.addClass('ec-section--' + scope.classSuffix);
            }

            scope.classWithModifier = function classWithModifier(baseClass) {
                return !scope.classSuffix ? baseClass : baseClass + ' ' + baseClass + '--' + scope.classSuffix;
            };

            scope.toggle = function toggleSection() {
                if (!scope.standalone) {
                    container.toggle(scope);
                } else {
                    scope.isExpanded = !scope.isExpanded;
                }
                if (container) {
                    container.trigger(scope.isExpanded ? _eventTopicExpanded : _eventTopicCollapsed, ['section', scope.sectionId]);
                }
            };

            scope.open = function open() {
                scope.isExpanded = true;
            };

            scope.close = function close() {
                scope.isExpanded = false;
            };
            scope.updateShow = function updateShow(newValue) {
                scope.show = newValue;
            };
            scope.setBreakpointClass = function setBreakpointClass(breakpointName, cols) {
                elem.removeClass(breakpointClasses[breakpointName]);
                breakpointClasses[breakpointName] = 'ms-neat-' + breakpointName + '-' + cols;
                elem.addClass(breakpointClasses[breakpointName]);
            };

            scope.config = morningstar.asterix.extend(true, {}, sectionDefaults);

            var prevWidth,
                prevBreakpoint = null,
                prevFooterTemplate = null;

            if (scope.parent == null) {
                scope.standalone = true;
                scope.isExpanded = true;
                elem.addClass('ec-section--standalone');

                if (scope.useCalculatedWidth) {
                    mstarDimensions(scope, elem).addListener(function (dimensions) {
                        var width = Math.min(dimensions.width, helper.MAX_WIDTH);
                        if (width === prevWidth) {
                            return;
                        }

                        prevWidth = width;

                        scope.$applyAsync(function () {
                            scope.width = width;
                            handleWidthChange(helper.MAX_COLS, scope.width);
                        });
                    });

                    scope.width = Math.min(elem.width(), helper.MAX_WIDTH);
                    handleWidthChange(helper.MAX_COLS, scope.width);
                } else {
                    mstarDimensions(scope, elem).addListener(function (dimensions) {
                        scope.$evalAsync(function () {
                            handleDimensions(dimensions);
                        });
                    });
                }

                scope.headerId = getSectionHeaderId();
                scope.panelId = getSectionPanelId();

                init();
            } else {
                if (!scope.useCalculatedWidth) {
                    mstarComponent.addUnregisterCallback(scope.parent.addWidthListener(function (dimensions) {
                        handleDimensions({
                            width: elem.width()
                        }, dimensions);
                    }));
                }

                if (scope.parentType === 'section') {
                    scope.isExpanded = true;
                    elem.addClass('ec-section--nested');

                    scope.headerId = getSectionHeaderId();
                    scope.panelId = getSectionPanelId();

                    init();

                    if (scope.useCalculatedWidth) {
                        mstarComponent.addUnregisterCallback(scope.parent.addWidthListener(function (parentWidth) {
                            handleWidthChange(helper.MAX_COLS, parentWidth);
                        }));

                        handleWidthChange(helper.MAX_COLS, scope.parent.getWidth());
                    }
                } else if (scope.parentType === 'container') {
                    elem.addClass('ec-columns');
                    scope.$applyAsync(function () {
                        scope.$on('$destroy', function destroySection() {
                            container.unregisterSection(scope);
                        });

                        container.registerSection(scope, function showFlagSetter(showFlag) {
                            if (showFlag) {
                                scope.cols = scope.previousCols || helper.MAX_COLS;
                            } else {
                                scope.previousCols = scope.cols;
                                scope.cols = 0;
                            }
                            scope.updateShow(showFlag);
                        });

                        init();
                    });
                }
            }

            function getSectionHeaderId() {
                return 'section-header-' + scope.$id;
            }

            function getSectionPanelId() {
                return 'section-panel-' + scope.$id;
            }

            function handleDimensions(elemDimensions, parentDimensions) {
                updateActiveSelfBreakpoint(elemDimensions);
                updateScopeProperties(parentDimensions || elemDimensions);
                helper.triggerWidthListeners(scope, elemDimensions);
            }

            function updateScopeProperties(dimensions) {
                // will be based on parent dimensions, if a parent exists
                helper.callWithActiveBreakpoint(scope.viewBreakpoints, dimensions, function (breakpoint) {
                    scope.cols = scope.config.breakpoints[breakpoint.name].cols;
                    scope.footerTemplate = !scope.config.breakpoints[breakpoint.name].footerTemplate ? null : '<div>' + scope.config.breakpoints[breakpoint.name].footerTemplate + '</div>';
                    if (scope.footerTemplate !== prevFooterTemplate) {
                        prevFooterTemplate = scope.footerTemplate;
                        if (scope.footerTemplate && !scope.footerElement) {
                            // compile the footerTemplate using the transcluded scope
                            scope.footerElement = $compile(scope.footerTemplate)(scope.$parent);
                            //elem.find('.ec-section__footer').empty();
                            $timeout(function () {
                                elem.find('.ec-section__footer').append(scope.footerElement);
                            }, 1000);
                        } else {
                            scope.footerElement = null;
                            $timeout(function () {
                                elem.find('.ec-section__footer').empty();
                            }, 1000);
                        }
                    }
                });
            }

            function handleWidthChange(cols, parentWidth) {
                var selfWidth = scope.width = helper.calculateSelfWidth(cols, parentWidth);

                scope.cols = cols;

                helper.callWithActiveBreakpoint(scope.viewBreakpoints, selfWidth, function (breakpoint) {
                    updateSelfBreakpoint(breakpoint.name);
                });

                helper.callWithActiveBreakpoint(scope.viewBreakpoints, parentWidth, function (breakpoint) {
                    refreshFooter(breakpoint.name);
                });

                helper.triggerWidthListeners(scope, selfWidth);
            }

            scope.handleWidthChange = handleWidthChange;

            function refreshFooter(parentBreakpointName) {
                scope.footerTemplate = !scope.config.breakpoints[parentBreakpointName].footerTemplate ? null : '<div>' + scope.config.breakpoints[parentBreakpointName].footerTemplate + '</div>';
                if (scope.footerTemplate !== prevFooterTemplate) {
                    prevFooterTemplate = scope.footerTemplate;
                    if (scope.footerTemplate && !scope.footerElement) {
                        // compile the footerTemplate using the transcluded scope
                        scope.footerElement = $compile(scope.footerTemplate)(scope.$parent);
                        $timeout(function () {
                            elem.find('.ec-section__footer').append(scope.footerElement);
                        }, 1000);
                    } else {
                        scope.footerElement = null;
                        $timeout(function () {
                            elem.find('.ec-section__footer').empty();
                        }, 1000);
                    }
                }
            }

            function updateActiveSelfBreakpoint(dimensions) {
                if (prevWidth === dimensions.width || !dimensions.width) {
                    return;
                }

                prevWidth = dimensions.width;

                elem.removeClass(_.map(scope.viewBreakpoints, function (bp, key) {
                    return 'ec-section--' + key;
                }).join(' '));

                helper.callWithActiveBreakpoint(scope.viewBreakpoints, dimensions, function (breakpoint) {
                    scope.breakpoint = breakpoint.name;
                    elem.addClass('ec-section--' + breakpoint.name);
                });

                if (prevBreakpoint !== scope.breakpoint) {
                    helper.triggerBreakpointListeners(scope);
                    prevBreakpoint = scope.breakpoint;
                }
            }

            function updateSelfBreakpoint(breakpointName) {
                if (scope.breakpoint === breakpointName) {
                    return;
                }

                scope.breakpoint = breakpointName;

                elem.removeClass(_.map(scope.viewBreakpoints, function (bp, key) {
                    return 'ec-section--' + key;
                }).join(' '));

                elem.addClass('ec-section--' + breakpointName);

                helper.triggerBreakpointListeners(scope);
            }

            function init() {
                if (!scope.useCalculatedWidth) {
                    morningstar.asterix.util.fastdom.measure(function () {
                        scope.$evalAsync(function () {
                            handleDimensions({
                                width: elem.width()
                            });
                        });
                    });
                }

                morningstar.asterix.util.fastdom.mutate(function () {
                    morningstar.asterix.util.each(scope.viewBreakpoints, function (breakpoint, key) {
                        addBreakpointClasses(key, scope.config.breakpoints[key]);
                    });

                    if (!scope.title) {
                        elem.addClass('ec-section--no-title');
                    }
                });
            }

            function addBreakpointClasses(breakpointName, breakpoint) {
                scope.setBreakpointClass(breakpointName, breakpoint.cols);
            }
        }
    }
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = {
	"ecContainer": {
		"labels": {
			"close": {
				"da-DK": "Luk",
				"en": "Close",
				"en-GB": null,
				"fr": "Fermer",
				"it": "Chiudi",
				"ja": "閉じる",
				"sv": "Stäng",
				"sv-SE": null,
				"zh-CN": "关闭",
				"zh-HK": "關閉"
			},
			"open": {
				"da-DK": "Åbn",
				"en": "Open",
				"en-GB": null,
				"fr": "Ouvrir",
				"it": "Aperto",
				"ja": "開く",
				"sv": "Öppna",
				"sv-SE": null,
				"zh-CN": "打开",
				"zh-HK": "打開"
			}
		},
		"settings": {
			"_templates": {
				"containerSectionSubtitle": "<h2 class=\"{{ :: classWithModifier('ec-section__subtitle') }}\" data-ng-if=\"subTitle\">{{ subTitle }}</h2>\r\n",
				"containerSectionTitle": "<h1 id=\"{{ :: headerId }}\" class=\"{{ :: classWithModifier('ec-section__title') }}\">\r\n    <span mstar-tooltip-content=\"{{ :: titleTooltipLabelId && labels.contains(titleTooltipLabelId) ? labels.get(titleTooltipLabelId) : '' }}\" mstar-tooltip data-ng-bind-html=\"title\"></span>\r\n</h1>\r\n"
			},
			"breakpoints": {
				"defaults": {
					"autoCollapseMode": "expand",
					"collapserPosition": "none"
				},
				"large": {},
				"medium": {},
				"small": {},
				"xlarge": {}
			},
			"debugMode": false,
			"defaultSection": {
				"breakpoints": {
					"defaults": {
						"cols": null
					},
					"large": {
						"autoCollapseMode": "none",
						"cols": 12
					},
					"medium": {
						"autoCollapseMode": "none",
						"cols": 12
					},
					"small": {
						"autoCollapseMode": "none",
						"cols": 12
					},
					"xlarge": {
						"autoCollapseMode": "none",
						"cols": 12
					}
				},
				"show": null
			},
			"enableToggleForExpand": false,
			"sections": null,
			"show": null
		},
		"type": "ecContainer"
	}
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar) {
    'use strict';

    morningstar.asterix.ng.register('ecContainer', __webpack_require__(6).ecContainer);
    morningstar.asterix.meta.register('ecContainer', 'skipInFullIdentifier', true);
    morningstar.asterix.meta.register('ecContainer', 'allowedEvents', ['ecContainerExpanded', 'ecContainerCollapsed']);

    __webpack_require__(4);
    __webpack_require__(5);
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = "<div data-ng-if=\"settings.get('debugMode') == true\">\r\n    <section>\r\n        <header>\r\n            <h1>Debug info</h1>\r\n        </header>\r\n        <div>\r\n            <h2>Sections</h2>\r\n            <ul>\r\n                <li data-ng-repeat=\"section in sections\">\r\n                    {{ section.sectionId }}\r\n                </li>\r\n            </ul>\r\n        </div>\r\n    </section>\r\n</div>\r\n<div data-ng-show=\"show\" data-ng-transclude>\r\n</div>\r\n";

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = "<div data-ng-show=\"show\" class=\"{{ :: classWithModifier('ec-section') }} ec-columns {{ ::classWithModifier('ec-section__group') }} {{ 'ms-neat-' + breakpoint + '-' + cols }} {{ !title ? 'ec-section--no-title' : '' }}\">\r\n    <section class=\"{{ :: classWithModifier('ec-section__section') }}\">\r\n        <header data-ng-if=\"title || collapsible\" class=\"{{ :: classWithModifier('ec-section__header') }} {{ :: collapsible ? 'ec-section__header--collapsible' : '' }}\"\r\n            data-ng-click=\"collapsible && toggle()\"\r\n            aria-controls=\"{{ :: groupSectionPanelId }}\"\r\n            data-ng-attr-aria-expanded=\"{{ collapsible ? isExpanded : undefined }}\"\r\n            tabindex=\"{{ collapsible ? 0 : -1 }}\">\r\n            <button type=\"button\" data-ng-if=\"collapsible\" class=\"{{ :: classWithModifier('ec-section__toggle') }} {{ isExpanded ? 'ec-section__toggle--expanded' : '' }}\" tabindex=\"-1\">\r\n                <span class=\"{{ :: classWithModifier('ec-section__toggle-caption') }}\">{{isExpanded ? labels.get('close') : labels.get('open')}}</span>\r\n            </button>\r\n            <h1 class=\"{{ :: classWithModifier('ec-section__title') }}\">\r\n                <span mstar-tooltip-content=\"{{ :: titleTooltipLabelId && labels.contains(titleTooltipLabelId) ? labels.get(titleTooltipLabelId) : '' }}\" mstar-tooltip data-ng-bind-html=\"title\"></span>\r\n            </h1>\r\n        </header>\r\n        <div id=\"{{ :: groupSectionPanelId }}\" class=\"ec-section__content {{ :: classWithModifier('ec-section__content') }} {{ isExpanded ? 'ec-section__content--expanded' : '' }}\" data-ng-show=\"!collapsible || isExpanded\">\r\n        </div>\r\n    </section>\r\n</div>\r\n";

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = "<div class=\"{{ :: classWithModifier('ec-section__section') }} {{ :: classWithModifier('ec-section__content') }} ec-section--no-header\" data-ng-if=\"cols > 0 && show\" data-ng-transclude>\r\n</div>\r\n";

/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = "<h2 class=\"{{ :: classWithModifier('ec-section__subtitle') }}\" data-ng-if=\"subTitle\">{{ subTitle }}</h2>\r\n";

/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = "<h1 id=\"{{ :: headerId }}\" class=\"{{ :: classWithModifier('ec-section__title') }}\">\r\n    <span mstar-tooltip-content=\"{{ :: titleTooltipLabelId && labels.contains(titleTooltipLabelId) ? labels.get(titleTooltipLabelId) : '' }}\" mstar-tooltip data-ng-bind-html=\"title\"></span>\r\n</h1>\r\n";

/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = "<section class=\"{{ :: classWithModifier('ec-section__section') }} {{ !title ? 'ec-section--no-header' : '' }}\" data-ng-if=\"cols > 0 && show\">\r\n    <header data-ng-if=\"title\" class=\"{{ :: classWithModifier('ec-section__header') }} {{ canBeCollapsed ? 'ec-section__header--collapsible' : '' }}\"\r\n        data-ng-click=\"canBeCollapsed && toggle()\"\r\n        aria-controls=\"{{ :: panelId }}\"\r\n        data-ng-attr-aria-expanded=\"{{ canBeCollapsed ? isExpanded : undefined }}\"\r\n        tabindex=\"{{ canBeCollapsed ? 0 : -1 }}\"\r\n        role=\"{{ canBeCollapsed ? 'button' : 'heading' }}\"\r\n        aria-labelledby=\"{{ :: headerId }}\">\r\n        <button type=\"button\" data-ng-if=\"collapsible\" class=\"{{ :: classWithModifier('ec-section__toggle') }} {{ isExpanded ? 'ec-section__toggle--expanded' : '' }}\" tabindex=\"-1\" aria-hidden=\"true\">\r\n            <span class=\"{{ :: classWithModifier('ec-section__toggle-caption') }}\">{{isExpanded ? labels.get('close') : labels.get('open')}}</span>\r\n        </button>\r\n        <div mstar-include=\"templates.containerSectionTitle\"></div>\r\n        <div mstar-include=\"templates.containerSectionSubtitle\"></div>\r\n    </header>\r\n    <div id=\"{{ :: panelId }}\" class=\"{{ :: classWithModifier('ec-section__content') }} {{ isExpanded ? 'ec-section__content--expanded' : '' }}\">\r\n        <div data-ng-if=\"isExpanded\">\r\n            <div data-ng-transclude></div>\r\n        </div>\r\n    </div>\r\n    <footer class=\"{{ :: classWithModifier('ec-section__footer') }}\" data-ng-show=\"isExpanded && footerElement\">\r\n    </footer>\r\n</section>\r\n";

/***/ })
/******/ ]);
//# sourceMappingURL=ec-container.js.map


// WEBPACK FOOTER //
// ./components/container/build/ec-container.js